export default __webpack_public_path__ + "navigation-examples-custom-server-thumbnail-480-5eca135937998aeecd74b6d04392a96f.webp";